import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';

import CallexLoader from '../../../components/CallexLoader';
import { listsDownload, listsPreview } from '../../../store/slices/tenantSlices/configurationSlice';

const ListResetPreviewModal = ({ isOpen, exportDetails, onCloseModal }) => {
  const dispatch = useDispatch();
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleExportDetails = async () => {
    try {
      const response = await dispatch(listsDownload(exportDetails)).unwrap();
      if (response) {
        const fileName = `${exportDetails?.status}.xlsx`;
        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log('Error exporting CSV:', error);
    }
  };

  const fetchExportDetails = async () => {
    try {
      setLoading(true);
      const response = await dispatch(listsPreview(exportDetails)).unwrap();
      if (response) {
        setReportData(response);
      }
    } catch (error) {
      console.log('Error exporting CSV:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchExportDetails();
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} size="xl" centered backdrop>
      <ModalBody>
        <div className="d-flex justify-content-between align-items-center py-2">
          <span className="fw-bold fs-5">List Preview</span>
          <div
            className="me-2 bg-info rounded-2 d-flex justify-content-center align-items-center"
            style={{ width: '30px', height: '30px', cursor: 'pointer' }}>
            <Icon.Download className="text-white" size={18} onClick={() => handleExportDetails()} />
          </div>
        </div>
        {loading ? (
          <div
            className="p-0 d-flex justify-content-center align-items-center m-0"
            style={{ height: 'calc(100vh - 215px)' }}>
            <CallexLoader />
          </div>
        ) : reportData?.data?.length > 0 ? (
          <div className="daily-report-table" style={{ height: 'calc(100vh - 215px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  {reportData?.headers?.map((val, index) => {
                    return <th key={index}>{val.header}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {reportData?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      {reportData?.headers?.map((value, idx) => {
                        return <td key={idx}>{val[value?.key] || '-'}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div
            className="p-0 d-flex justify-content-center align-items-center no-data m-0"
            style={{ height: 'calc(100vh - 215px)' }}>
            No data available
          </div>
        )}
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button className="px-5 bg-danger border-danger" onClick={() => onCloseModal()}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ListResetPreviewModal.propTypes = {
  isOpen: PropTypes.any,
  exportDetails: PropTypes.any,
  onCloseModal: PropTypes.func
};

export default ListResetPreviewModal;
